import { useChartRootRef } from "@mui/x-charts/hooks";

/**
 * CustomChartWrapper is a React component that provides a styled wrapper for chart components.
 * It uses a custom chart root ref and applies flexbox styling to center its children vertically.
 *
 * @function
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to be rendered inside the wrapper.
 * @returns {JSX.Element} The styled wrapper containing the children.
 */
export default function CustomChartWrapper({ children, isApiPrint = false }) {
  const chartRootRef = useChartRootRef();
  return (
    <div
      ref={chartRootRef}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: isApiPrint ? "#ffffff" : "transparent",
        padding: 8,
      }}
    >
      {children}
    </div>
  );
}
